import { WorkSpace } from "./Chapters/WorkSpace/WorkSpace"
import { ChapterConfig } from "./ChapterConfig"
import { Intro } from "./Chapters/Intro/Intro"
import { Hex } from "./Chapters/Hex/Hex"
import { HexPatternChapter } from "./Chapters/HexPattern/HexPatternChapter"
import { DiatonicChordsChapter } from "./Chapters/DiatonicChords/DiatonicChordsChapter"
import { ModesChapter } from "./Chapters/Modes/ModesChapter"
import { BuildingTheHexKey } from "./Chapters/BuildingTheHexKey/BuildingTheHexKey"
import { SubstituteChords } from "./Chapters/SubstituteChords/SubstituteChords"
import { PentatonicScaleChapter } from "./Chapters/PentatonicScale/PentatonicScaleChapter"
import { BluesScaleChapter } from "./Chapters/BluesScale/BluesScale"
import { ChainOfFifthsChapter } from "./Chapters/ChainOfFifths/ChainOfFifthsChapter"
import { HexKeyAnatomyChapter } from "./Chapters/HexKeyAnatomy/HexKeyAnatomyChapter"
import { HexMapChapter } from "./Chapters/HexMapChapter/HexMapChapter"
import { HexMapNotesChapter } from "./Chapters/HexMapNotesChapter/HexMapNotesChapter"
import { BorrowedChordsChapter } from "./Chapters/BorrowedChords/BorrowedChords"
import { KeyCompassChapter } from "./Chapters/KeyCompass/KeyCompassChapter"
import { SecondaryDominantsChapter } from "./Chapters/SecondaryDominantsChapter/SecondaryDominantsChapter"
import { IntervalsChapter } from "./Chapters/Intervals/IntervalsChapter"
import { CycleOfFifths } from "./Chapters/HarmonicCycles/CycleOfFifths/CycleOfFifths"
import { CycleOfThirds } from "./Chapters/HarmonicCycles/CycleOfThirds/CycleOfThirds"
import { CycleChromatic } from "./Chapters/HarmonicCycles/CycleChromatic/CycleChromatic"
import { CycleOfFlatThirds } from "./Chapters/HarmonicCycles/CycleOfFlatThirds/CycleOfFlatThirds"
import { CycleOfSeconds } from "./Chapters/HarmonicCycles/CycleOfSeconds/CycleOfSeconds"
import { FretBoardChapter } from "./Chapters/FretBoard/FretBoardChapter"
import { HexPlayerChapter } from "./Chapters/HexPlayer/HexPlayerChapter"


export class CourseNavigation{
    static getIntroChapters = () => {
        return [new ChapterConfig("/Intro", "Introduction", Intro)]
    }
    static getDiatonicChapters = () => {
        const diatonicChapters:ChapterConfig[] = [
            new ChapterConfig("/Hex", "The Hex Map", Hex),
            new ChapterConfig("/HexPattern", "The HexKey Pattern", HexPatternChapter),
            new ChapterConfig("/BuildingTheHexKey", "Building The HexKey", BuildingTheHexKey),
            new ChapterConfig("/IntervalNames", "Interval Names", IntervalsChapter),
            new ChapterConfig("/DiatonicChords", "Diatonic Chords", DiatonicChordsChapter),
            new ChapterConfig("/SubstituteChords", "Substitute Chords", SubstituteChords),
            new ChapterConfig("/Modes", "The Modes", ModesChapter),
            new ChapterConfig("/PentatonicScale", "The Pentatonic Scale", PentatonicScaleChapter),
            new ChapterConfig("/BluesScale", "The Blues Scale", BluesScaleChapter),
            new ChapterConfig("/ChainOfFifths", "The Chain of Fifths", ChainOfFifthsChapter),
            new ChapterConfig("/HexKeyAnatomy", "The Anatomy of a HexKey", HexKeyAnatomyChapter),
        ]
        return diatonicChapters
    }
    static getMultiKeyChapters = () => {
        const multiKeyChapters:ChapterConfig[] = [
            new ChapterConfig("/HexMap", "The HexMap Structure", HexMapChapter),
            new ChapterConfig("/HexMapNotes", "HexMap Notes", HexMapNotesChapter),
            new ChapterConfig("/BorrowedChords", "Borrowed Chords", BorrowedChordsChapter),
            new ChapterConfig("/KeyCompass", "Relative Keys and The Key Compass", KeyCompassChapter),
            new ChapterConfig("/SecondaryDominants", "Secondary Dominants", SecondaryDominantsChapter),
            new ChapterConfig("/HexMapCircleOfFifths", "The Circle of Fifths in the HexMap", CycleOfFifths),
            new ChapterConfig("/CycleOfFlatThirds", "The Cycle of Flat Thirds in the HexMap", CycleOfFlatThirds),
            new ChapterConfig("/CycleOfThirds", "The Cycle of Thirds in the HexMap", CycleOfThirds),
            new ChapterConfig("/CycleOfSeconds", "The Cycle of Seconds in the HexMap", CycleOfSeconds),
            new ChapterConfig("/CycleChromatic", "The Chromatic Scale in the HexMap", CycleChromatic),
        ]
        return multiKeyChapters
    }
    static getUtilChapters = () => {
        const utilChapters:ChapterConfig[] = [
            new ChapterConfig("/WorkSpace", "WorkSpace", WorkSpace),
            new ChapterConfig("/FretBoard", "Fret Board", FretBoardChapter),
            new ChapterConfig("/HexPlayer", "HexKey Player", HexPlayerChapter)
        ]
        return utilChapters
    }
    static getAllChapters = () => {
        return  [   CourseNavigation.getIntroChapters(),
                    CourseNavigation.getDiatonicChapters(),
                    CourseNavigation.getMultiKeyChapters(),
                    CourseNavigation.getUtilChapters()
                ].flat()
    }   
}
